import { useHistory } from "react-router-dom";

const DetailHeader = (props) => {
    const {headerTitle, arrowYn=false, closeYn=false} = props;
    const navigate = useHistory();

    const goBack = () => {
        navigate.goBack();
    }

    const goMain = () => {
        if(sessionStorage.getItem('SI')){
            let tempSi = sessionStorage.getItem('SI');
            sessionStorage.clear();
            sessionStorage.setItem('SI',tempSi);
        }else{
            sessionStorage.clear();
        }
        navigate.push('/');
    }

    return(
        <>
        {/* 상세화면 일때  */}
        <div className="header">
            <a onClick={() =>{goBack()}} className={`btnArrow ${arrowYn ? '' : 'dpNone'}`}>이전으로</a>
            <h1 className="conTitle">
                {/* 그냥 문구일때 */}
                <span className="textWrap">
                    <span className="text">{headerTitle}</span>
                </span>
                {/* selectbox 일때 */}
                <span className="textWrap dpNone">
                    <select>
                        <option>장부(매출/매입)관리</option>
                        <option>장부(매출/매입)관리 장부(매출/매입)관리 장부(매출/매입)관리</option>
                        <option>선택하세요2</option>
                    </select>
                </span>
            </h1>                
            {closeYn ? <a onClick={() =>{goMain()}} className="btnClose">닫기</a> : ""}
        </div>
        {/* //상세화면 일때  */}
        </>
    )
}
export default DetailHeader